import {
    PortfolioEnterpriseGroupAddParameters,
    PortfolioEnterpriseGroupUpdateParameters,
} from '@mews-commander/data-access';

export type FormValues = Pick<PortfolioEnterpriseGroupAddParameters, 'name' | 'description'> &
    Pick<PortfolioEnterpriseGroupUpdateParameters, 'id'>;

export const DEFAULT_VALUES: FormValues = {
    name: '',
    description: '',
    id: '',
};

export enum FIELD_NAMES {
    NAME = 'name',
    DESCRIPTION = 'description',
    PROPERTY_GROUP_ID = 'id',
}
